import { ArrowPathIcon } from '@heroicons/react/24/outline'

import { anim, pv } from '../../../../motion'
import { useCopy } from '../../../i18n'
import { MaskText } from '../../stage/fx'

// Partikel formen nacheinander die Ziffern 1, 2 und 3
const digit = (d) => (w, h, narrow) => ({
  type: 'text',
  text: String(d),
  x: narrow ? w / 2 : w * 0.72,
  y: narrow ? h * 0.7 : h * 0.5,
  size: narrow ? h * 0.36 : Math.min(h * 0.8, w * 0.42),
  dot: 0.85
})

export const STEPS_PARTICLES = [
  [0.06, digit(1)],
  [0.36, digit(2)],
  [0.66, digit(3)],
  [0.9, digit(3)]
]

const WINDOWS = [
  [0.04, 0.34],
  [0.34, 0.64],
  [0.64, 1.2]
]

export default function DmsSteps() {
  const c = useCopy('schritte')
  const s = useCopy('show')

  return (
    <div className='sc-full dms-steps'>
      <div className='dms-steps__col'>
        <div className='sc-eyebrow'>{c.eyebrow}</div>
        <h2 className='sc-h2 dms-steps__title'>
          <MaskText text={s.stepsTitle} at={[0, 0.1]} />
        </h2>
        <ol className='dms-steps__list'>
          {c.steps.map((step, i) => (
            <li
              key={step.title}
              className='dms-step'
              style={{
                ...pv('a', [WINDOWS[i][0], WINDOWS[i][0] + 0.06]),
                ...pv('b', [WINDOWS[i][1], WINDOWS[i][1] + 0.04])
              }}
            >
              <span className='dms-step__num'>0{i + 1}</span>
              <div>
                <div className='dms-step__title'>{step.title}</div>
                <div className='dms-step__text'>{step.text}</div>
              </div>
            </li>
          ))}
        </ol>
        <div className='dms-addon' style={anim({ at: [0.82, 0.9], y: 30 })}>
          <ArrowPathIcon className='dms-addon__icon' />
          <span>
            <b>{c.addon}</b> {c.addonText}
          </span>
        </div>
      </div>
    </div>
  )
}
